<template>
  <div class="feedback-carousel py-20">
    <Splide :options="options" ref="splide">
      <SplideSlide v-for="(review, index) in reviews" :key="review.id">
        <div class="bg-white p-8 relative m-auto" style="width:90%;">
          <div class="rating">
          <star-rating :rating="convert(review.rating)"
          :star-size="20" 
          :read-only="true"
          active-color="#00bfff"
          :show-rating="false"
          ></star-rating>
          </div>
          <p class="text-3xl text-left" v-html="review.title.rendered"></p>
          <p class="text-2xl text-justify" v-html="review.content.rendered"></p>
          
          
          </div>
          
      </SplideSlide>
    </Splide>
  </div>
</template>

<script>

import { ref, onMounted } from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import StarRating from 'vue-star-rating';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import { getReviews } from '../../scripts/getAxios';

export default {
name: "reviews",
  components: {
    Splide,
    SplideSlide,
    StarRating
    
  },
  setup() {
    const reviews = ref([])
    const splide = ref(null);
    const rating = '5'
    const options = {
    rewind : true,
    perPage: 2,
    breakpoints: {
        640: {
          perPage: 1, // Su schermi con larghezza <= 640px, mostra una sola slide
        },
        768: {
          perPage: 2, // Su schermi con larghezza <= 768px, mostra 2 slide
        },
        1024: {
          perPage: 2, // Su schermi con larghezza <= 1024px, mostra 3 slide
        },
      },
    pagination:true,
    arrow: true,
    autoplay: true
  }
  
    const feedbacks = [
      {
        name: "John Doe",
        comment: "Great service, would highly recommend!",
        rating: 5, // Valutazione da 1 a 5
      },
      {
        name: "Jane Smith",
        comment: "Excellent product quality and fast delivery.",
        rating: 4,
      },
      // Aggiungi altre recensioni se necessario
    ];
    const importReviews = async () => {
          await getReviews(`${process.env.WORDPRESS_BASE_URL}/wp-json/wp/v2/reviews`).then(response => {
              reviews.value.push(...response.data)
          })
      }

    const convert = (stringa) => {
      return parseInt(stringa)
    }

    onMounted(async () => {
          importReviews()
         
      })

    return {
      reviews,
      splide,
      options,
      rating,
      convert
      
    };
  },
};
</script>

<style lang="scss" scoped>
.skeleton-carousel {
display: flex;
justify-content: center;
}

.skeleton-slide {
width: 300px;
height: 200px;
background-color: #f0f0f0;
margin: 0 10px;
}
.feedback-carousel {
 
  margin: 0 auto;

  .feedback-card {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
  }

  .splide__arrow {
    background-color: rgba(255, 255, 255, 0.7);
    color: #333;
    border: none;
    padding: 10px 20px;
    border-radius: 50%;
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 100;
    transition: background-color 0.3s;
    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }
    &--prev {
      left: 20px;
    }
    &--next {
      right: 20px;
    }
  }

  .star-rating {
    display: inline-block;
  }

  .star-rating .star {
    color: #FFD700;
    font-size: 18px;
  }

  .star-rating .star--empty {
    color: #ccc;
  }
}
</style>
